import { MachineRuleTypeToTextMap, getMachineRuleTypeColor } from "@/enum/dict";

// 命中规则和注意事项共用类型名称、配色及序号。
function buildRuleRow(record, index) {
  return {
    index: index + 1,
    ruleTypeText:
      MachineRuleTypeToTextMap.get(Number(record.ruleType)) ||
      (record.ruleTypeText ?? "-"),
    ruleTypeColor: getMachineRuleTypeColor(record.ruleType),
    hitRule: record.hitRule ?? "-",
  };
}

// 转换命中规则，首付比缺失时显示占位符。
export function buildHitRuleRows(list) {
  return (Array.isArray(list) ? list : []).map((record, index) => ({
    ...buildRuleRow(record, index),
    isEffective: record.isEffective === true,
    hitPrepayRate:
      record.hitPrepayRate === null ||
      record.hitPrepayRate === undefined ||
      record.hitPrepayRate === ""
        ? "-"
        : String(record.hitPrepayRate) + "%",
    hitSuggest: record.hitSuggest ?? "-",
  }));
}

// 转换注意事项，保留命中文案和备注。
export function buildNoticeRuleRows(list) {
  return (Array.isArray(list) ? list : []).map((record, index) => ({
    ...buildRuleRow(record, index),
    remark: record.remark ?? "-",
  }));
}
